module.exports = __webpack_public_path__ + "img/yin.9939239c.png";